window.mx = window.mx || {};

window.mx.MxFeaturedProduct = class extends window.mx.MxSection {
  constructor() {
    super();

    this.cachedProductData = null;
  }

  connectedCallback() {}

  get productData() {
    if (this.cachedProductData === null) {
      const sectionId = this.section.id;
      this.cachedProductData = JSON.parse(this.querySelector(`#${sectionId}__product-data`).textContent);
    }
    return this.cachedProductData;
  }
};
if (!window.customElements.get('mx-featured-product'))
  window.customElements.define('mx-featured-product', window.mx.MxFeaturedProduct);

window.mx.MxVariantPicker = class extends window.mx.MxComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectList.forEach(
      (select) => this.eventManager.addListener(select, 'change', (event) => this.onVariantChange(event)),
      'change',
    );
  }

  get selectList() {
    return this.querySelectorAll('select');
  }
  get addToCartContainer() {
    return this.section.querySelector('.block-container--add-to-cart');
  }
  get productData() {
    return this.section.querySelector('.mx-featured-product').productData;
  }
  get optionHandle() {
    const classicProduct = this.productData.classic_product;

    const optionHandle = Array.from(this.selectList)
      .map((select) => select.value)
      .join('');

    if (!classicProduct) {
      const purchaseMethod = this.productData.purchase_method;
      return `${purchaseMethod}-${optionHandle}`;
    }

    return optionHandle;
  }
  get variant() {
    return this.getVariantFromOptionHandle(this.optionHandle);
  }

  onVariantChange() {
    const purchaseMethod = this.productData.purchase_method;
    let newVariant = this.variant;

    if (purchaseMethod === 'reservation' && newVariant.available === false) {
      const newOptionHandle = newVariant.option_handle.replace('reservation', 'stock');
      newVariant = this.getVariantFromOptionHandle(newOptionHandle);
    }

    this.productData.current_variant = newVariant.id;

    newVariant.available
      ? this.addToCartContainer.setAttribute('data-variant-status', 'available')
      : this.addToCartContainer.setAttribute('data-variant-status', 'out-of-stock');
  }

  getVariantFromOptionHandle(handle) {
    return Object.values(this.productData.variants).find((variant) => variant.option_handle === handle);
  }
};
if (!window.customElements.get('mx-variant-picker'))
  window.customElements.define('mx-variant-picker', window.mx.MxVariantPicker);

window.mx.MxAddToCart = class extends window.mx.MxComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.eventManager.addListener(this, 'click', () => this.onClick());
  }

  get productData() {
    return this.section.querySelector('.mx-featured-product').productData;
  }

  async onClick() {
    try {
      this.setAttribute('disabled', '');

      const cartSectionId = document.querySelector('.shopify-section-cart-drawer').id.split('shopify-section-').pop();

      const giftCardInfos = document.querySelector('.gift-card-recipient-form');

      // Parse gift card recipient form inputs
      const giftCardCheckbox = document.querySelector('#gift-card-recipient-checkbox');
      const isGiftCardRecipient = giftCardCheckbox?.checked ?? false;

      const recipientEmail = giftCardInfos?.querySelector('#gift-card-recipient-email')?.value || '';
      const recipientName = giftCardInfos?.querySelector('#gift-card-recipient-name')?.value || '';
      const recipientMessage = giftCardInfos?.querySelector('#gift-card-recipient-message')?.value || '';
      const sendOnDate = giftCardInfos?.querySelector('#gift-card-recipient-date')?.value || '';

      const { current_variant, purchase_method, reservation_campaign, country, fabric } = this.productData;

      const addToCartBody = {
        items: [
          {
            id: current_variant,
            quantity: 1,
            properties: {
              _purchase_method: purchase_method,
              _reservation_campaign: reservation_campaign,
              _country: country,
              _fabric: fabric,
              ...(isGiftCardRecipient && {
                __shopify_send_gift_card_to_recipient: true,
                'Recipient email': recipientEmail,
                'Recipient name': recipientName,
                'Message': recipientMessage,
                'Send on': sendOnDate,
              }),
            },
          },
        ],
        sections: [cartSectionId],
      };

      console.log(addToCartBody);

      const addToCartJson = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(addToCartBody),
      }).then((response) => response.json());

      console.log(addToCartJson);

      refreshCartUserInterface(addToCartJson.sections[cartSectionId]);
      openCartDrawerHandler();
    } catch (error) {
      console.error('Error adding to cart', error);
    } finally {
      this.removeAttribute('disabled', '');
      window.mx.hideGorgiasButton();
    }
  }
};
if (!window.customElements.get('mx-add-to-cart')) window.customElements.define('mx-add-to-cart', window.mx.MxAddToCart);

window.mx.MxBackInStock = class extends window.mx.MxComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.eventManager.addListener(this, 'click', () => this.onClick());
  }

  get productData() {
    return this.section.querySelector('.mx-featured-product').productData;
  }

  onClick() {
    const variantDataJson = this.productData['back_in_stock'];

    if (!BIS) {
      console.error('Back In Stock not loaded');
      return false;
    }

    BIS.Config.product = variantDataJson;

    BIS.popup = BIS.createPopover();
    BIS.popup?.toggle();
    BIS.popup?.form?.frame?.contentDocument?.querySelector('.action-close')?.style?.setProperty('display', 'block');
    BIS.popup?.form?.frame?.contentDocument?.querySelector('#variants')?.querySelectorAll('option')?.forEach((option) => {
      if (option.textContent.startsWith('Réservation')) {
        option.remove();
      }
    });
  }
};
if (!window.customElements.get('mx-back-in-stock'))
  window.customElements.define('mx-back-in-stock', window.mx.MxBackInStock);


window.mx.MxStickyAddToCart = class extends window.mx.MxComponent {
  constructor() {
    super();
    if (window.mx.MxStickyAddToCart.instance) {
      return window.mx.MxStickyAddToCart.instance;
    }
    window.mx.MxStickyAddToCart.instance = this;

    this.originalButtonContainer = document.querySelector('.block-container--add-to-cart');
    if (!this.originalButtonContainer) {
      console.warn("⚠️ MxStickyAddToCart: '.block-container--add-to-cart' introuvable");
      return;
    }
    this.dataset.visible = 'no';
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.onScroll();
  }

  onScroll() {
    if (!this.originalButtonContainer) return;

    const rect = this.originalButtonContainer.getBoundingClientRect();
    const isStickyVisible = rect.bottom < 0;
    const wasVisible = this.dataset.visible === 'yes';
    this.setAttribute('data-visible', isStickyVisible ? 'yes' : 'no');

    if (isStickyVisible !== wasVisible) {
      this.dispatchEvent(new CustomEvent('sticky-add-to-cart:visibility-changed', {
        bubbles: true,
        detail: { visible: isStickyVisible }
      }));
    }

    const variantStatus = this.originalButtonContainer.getAttribute('data-variant-status');
    if (variantStatus) {
      this.setAttribute('data-variant-status', variantStatus);
    }

    const scrollToTopButton = document.querySelector('.mx-scroll-to-top');
    const chatButton = document.querySelector('#chat-button');

    if (scrollToTopButton) {
      scrollToTopButton.classList.toggle('with-scroll-to-top', isStickyVisible);
    }

    if (chatButton) {
      const isSmallScreen = window.matchMedia('(max-width: 59.99rem)').matches;
      chatButton.style.bottom = isStickyVisible ? (isSmallScreen ? '60px' : '75px') : '20px';
    }
  }
};



if (!window.customElements.get('mx-sticky-add-to-cart')) {
  window.customElements.define('mx-sticky-add-to-cart', window.mx.MxStickyAddToCart);
}
